import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { IMappers, IMyHomeObjectsExistsResponse } from 'shared/repositories/price-estimator/v1/my-home-objects-exists';

export const createMyHomeObjectExistMapper = (): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response.isExists,
  400: ({ message }) => {
    return new HttpBadStatusCodeError({
      domain: 'fetchIsMyHomeObjectsExist.ts',
      statusCode: 400,
      message: message || /* istanbul ignore next */ '',
    });
  },
});

export type TMappedResponse200 = IMyHomeObjectsExistsResponse['isExists'];
export type TMappedResponse400 = HttpBadStatusCodeError;

export type TMappedResponse = TMappedResponse200 | TMappedResponse400;
